export default __webpack_public_path__ + "static/client-5-399f21ec5022f937ad95be7e38ed270b.webp";